import type { BrandMode } from '@garage/shared';
import { useSyncExternalStore } from 'react';

/**
 * Aperçu en direct de la marque (Compte → Marque) : brouillon appliqué à toute l'interface du garage
 * avant l'enregistrement. `null` = aucune modification en cours (la marque enregistrée s'applique).
 * Rien n'est persisté : quitter l'écran, annuler ou recharger revient à la marque enregistrée.
 */
export interface BrandDraft {
  primaryColor?: string;
  secondaryColor?: string;
  tertiaryColor?: string | null;
  brandMode?: BrandMode;
}

let draft: BrandDraft | null = null;
const listeners = new Set<() => void>();

export function setBrandDraft(next: BrandDraft | null): void {
  draft = next;
  for (const l of listeners) l();
}

function subscribe(l: () => void): () => void {
  listeners.add(l);
  return () => listeners.delete(l);
}

export function useBrandDraft(): BrandDraft | null {
  return useSyncExternalStore(
    subscribe,
    () => draft,
    () => null,
  );
}
